import { inputResult } from "../Submit/SaveAnswer";

export function transformSfToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    let [title, add] = '';

    if (results.answer == results.correct){
        add = 'is-valid';
    } else {
        add = 'is-invalid';
        title = 'Richtige Antwort: ' + findCorrectSfChoice(input, results.correct);
    }

    const answerIndex = (results.answer != '') ? results.answer : -1;
    selectSelectedSfChoice(input, answerIndex);

    input.addClass(add);
    input.attr('title', title);
    input.prop('disabled', true);

}

export function selectSelectedSfChoice(input:JQuery, answerIndex:number){
    return input.find("option[value=" + answerIndex +"]").attr('selected', 'selected');
}

function findCorrectSfChoice(input:JQuery, correctIndex:number){
    return input.find("option[value=" + correctIndex + "]").html();
}